import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CarsFillGreenOnBlue__IconWrapper",
  componentId: "sc-s0ls71-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 46 42",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    filter: "url(#CarsFillGreenOnBlue_tsx__a)"
  }, React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    fillRule: "evenodd",
    d: "M16.666 32.768c0 1.664-1.538 2.95-3.417 3.058l-.258.007h-.566c-1.883 0-3.491-1.181-3.661-2.8l-.015-.224v-3.31h-.794a2.37 2.37 0 0 1-1.55-.643l-.174-.18a2.64 2.64 0 0 1-.642-1.55l-.005-.244.001-6.235a5.72 5.72 0 0 1 1.574-3.815l-.215.001a2.2 2.2 0 0 1-1.49-.546 1.95 1.95 0 0 1-.652-1.24l-.011-.206v-.555c0-1.164.952-2.088 2.137-2.193l.225-.01h2.196l.282-.942.652-2.012q.18-.733.565-1.417a4 4 0 0 1 1.719-1.554 5.1 5.1 0 0 1 1.954-.409l.323.01 16.327.001a5.15 5.15 0 0 1 2.361.413 4 4 0 0 1 1.696 1.558c.185.33.336.676.447 1.022l.7 2.405.276.924 2.195.001c1.21 0 2.235.856 2.35 1.987l.012.216v.555c0 .551-.243 1.073-.664 1.446a2.2 2.2 0 0 1-1.25.537l-.23.01-.22-.002a5.74 5.74 0 0 1 1.55 3.45l.022.37.001 6.21a2.65 2.65 0 0 1-.646 1.814 2.4 2.4 0 0 1-1.494.804l-.253.02-.775-.001v3.27c0 1.66-1.517 2.948-3.373 3.057l-.256.007h-.658c-1.885 0-3.485-1.216-3.62-2.84l-.01-.225V29.5H16.667z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    fillRule: "evenodd",
    d: "m35.308 16.833.247.017c1.71.183 3.087 1.67 3.262 3.555l.017.272v6.206l-.007.172a1.05 1.05 0 0 1-.246.576.83.83 0 0 1-.452.271l-.128.015H7.978l-.116-.015a.84.84 0 0 1-.44-.27 1.05 1.05 0 0 1-.247-.566l-.007-.163v-5.97l.002-.276c.078-2.004 1.49-3.616 3.278-3.807l.247-.017zm-2.016 2.375a3.167 3.167 0 1 0 0 6.334 3.167 3.167 0 0 0 0-6.334m-20.584 0a3.167 3.167 0 1 0 0 6.334 3.167 3.167 0 0 0 0-6.334m15.043 2.375h-9.5l-.143.013a.792.792 0 0 0 0 1.558l.143.013h9.5l.142-.013a.792.792 0 0 0 0-1.558zm11.095-7.916.145.01c.325.05.566.26.621.503l.012.106v.555l-.014.091a.4.4 0 0 1-.117.171.6.6 0 0 1-.301.138l-.12.009-1.485-.001-.466-1.583zm-29.968-.001-.464 1.583H6.936l-.125-.008a.6.6 0 0 1-.305-.138.4.4 0 0 1-.116-.17l-.015-.092v-.555l.012-.106c.055-.244.296-.454.622-.503l.144-.01z",
    clipRule: "evenodd"
  }), React.createElement("g", {
    filter: "url(#CarsFillGreenOnBlue_tsx__b)"
  }, React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "m14.465 7.335.329.005 16.427.002.354-.006q.696.02 1.305.28c.386.186.738.508.979.91.124.222.23.467.313.724l.074.26.611 2.096.779 2.613.32 1.087-.296-.037-.3-.019H10.668l-.314.02-.31.04.323-1.094.776-2.606.662-2.047.082-.291a4 4 0 0 1 .33-.765c.23-.383.583-.705 1.003-.907.379-.16.807-.253 1.244-.265",
    clipRule: "evenodd"
  })), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "M15.082 32.768V30.02h-4.75v2.77l.015.153c.106.601.749 1.132 1.623 1.272l.223.026.231.009h.566l.235-.01c.996-.079 1.744-.66 1.845-1.319zm20.584 0V30.02h-4.75v2.748l.012.154c.092.61.722 1.15 1.585 1.292l.22.027.229.009h.658l.23-.01c.973-.078 1.705-.657 1.804-1.318z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    d: "M10.33 29.5h4.75v1h-4.75z"
  }), React.createElement("path", {
    fill: themeGet("palette.highlight.light")(themeProps),
    stroke: themeGet("palette.pricePrimary.dark")(themeProps),
    d: "M15.701 22.4a3 3 0 1 0-6 0 3 3 0 0 0 6 0Zm20.582 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    d: "M30.92 29.5h4.75v1h-4.75z"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "CarsFillGreenOnBlue_tsx__a",
    width: 48,
    height: 48,
    x: -1,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 2
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.12 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_5713"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 1
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.16 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_258_5713",
    result: "effect2_dropShadow_258_5713"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect2_dropShadow_258_5713",
    result: "effect3_dropShadow_258_5713"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: -1
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.03 0"
  }), React.createElement("feBlend", {
    in2: "effect3_dropShadow_258_5713",
    result: "effect4_dropShadow_258_5713"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect4_dropShadow_258_5713",
    result: "shape"
  })), React.createElement("filter", {
    id: "CarsFillGreenOnBlue_tsx__b",
    width: 25.911,
    height: 8.474,
    x: 10.045,
    y: 7.335,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_5713"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_5713",
    result: "shape"
  }))));
}
const CarsFillGreenOnBlue = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CarsFillGreenOnBlue);
export default Memo;